import WebComponent from "../../WebComponent";
import {css, html} from "@isceco/widget-library2/external/lit";
import '@isceco/widget-library2/basic-elements/Title/Title'
import '@isceco/widget-library2/basic-elements/Form/Form'
import '@isceco/widget-library2/basic-elements/Card/Card'
import '@isceco/widget-library2/basic-elements/TextInput/TextInput'
import '@isceco/widget-library2/basic-elements/List/InputList.js';
import '@isceco/widget-library2/basic-elements/Message/Message.js'
import FormConfigService from "../../services/FormConfigService";
import FormConfigDto from '../Administration/FormConfigDto'
import AdministrationEditColumns from './AdministrationEditColumns'

export default class AdministrationEdit extends WebComponent {

  constructor() {
    super()
    this.formConfigService = new FormConfigService()
  }

  get translationFile() {
    return './views/AdministrationEdit/i18n.json'
  }

  get css() {
    return css`
      .inline {
        display: flex;
        flex-flow: row nowrap;
        align-items: flex-start;
        gap: var(--isceco-space-300);
      }
      .inline > * {
        flex-grow: 1;
      }
    `
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  reload() {
    Promise.resolve(
      this.formConfigService.read(getNavigationId())
    ).then(json => {
      this.formConfig = new FormConfigDto(json)
      this.render()
    })
  }

  getTemplate() {
    return html`
      <isceco-title id="page-title" text="${this.formConfig.formKey}"
      ></isceco-title>
      <isceco-form id="formconfig-edit-form"
                   .value="${this.formConfig}"
                   submit-button-text="${this.i18n.translate('administration.edit.save')}"
                   abort-button-text="${this.i18n.translate('administration.edit.cancel')}"
                   @submit="${e => this._submit(e.detail)}"
                   @abort="${_ => navigate({to: 'Administration'})}"
      >
        <div slot="form-elements">
          ${this._renderBeschreibung()}
          <div class="inline" style="margin-top: var(--isceco-space-300)">
            ${this._renderMonitoringEmails()}
            ${this._renderAccessWhitelist()}
          </div>
        </div>
      </isceco-form>
    `
  }

  _renderBeschreibung() {
    const NAME_KEY = 'administration.edit.name'
    return html`
      <isceco-card text="${this.i18n.translate('administration.edit.translation')}">
        <div class="inline">
          <isceco-text-input name="beschreibung.nameDe"
                             label="${this.i18n.translate(NAME_KEY)} DE"
          ></isceco-text-input>
          <isceco-text-input name="beschreibung.nameFr"
                             label="${this.i18n.translate(NAME_KEY)} FR"
          ></isceco-text-input>
          <isceco-text-input name="beschreibung.nameIt"
                             label="${this.i18n.translate(NAME_KEY)} IT"
          ></isceco-text-input>
          <isceco-text-input name="beschreibung.nameEn"
                             label="${this.i18n.translate(NAME_KEY)} EN"
          ></isceco-text-input>
        </div>
      </isceco-card>
    `
  }

  _renderMonitoringEmails() {
    return html`
      <isceco-card text="${this.i18n.translate('administration.edit.monitoring')}">
        <isceco-input-list name="monitoringEmails"
                           .i18n="${this.i18n}"
                           .columns="${AdministrationEditColumns.getColumns(this.i18n)}"
        ></isceco-input-list>
      </isceco-card>
    `
  }

  _renderAccessWhitelist() {
    return html`
      <isceco-card text="${this.i18n.translate('administration.edit.access')}"
                   help-text="${this.i18n.translate('administration.edit.access.info')}"
                   help-text-size="large">
        <isceco-input-list name="accessEmails"
                           .i18n="${this.i18n}"
                           .columns="${AdministrationEditColumns.getColumns(this.i18n)}"
        ></isceco-input-list>
      </isceco-card>
    `
  }

  _submit = json => {
    json.id = this.formConfig.id
    json.formKey = this.formConfig.formKey
    json.monitoringEmails = json.monitoringEmails.map(v => v.email)
    json.accessEmails = json.accessEmails.map(v => v.email)

    this.formConfigService.update(json)
      .then(() => {
        showAlert(
          this.i18n.translate('administration.edit.alert.title.success'),
          this.i18n.translate('administration.edit.alert.success'),
          'success'
        )
        navigate({to: 'Administration'})
      })
      .catch(() => {
        showAlert(
          this.i18n.translate('administration.edit.alert.title.error'),
          this.i18n.translate('administration.edit.alert.error'),
          'error'
        )
      })
  }

}

customElements.define('eform-frontend-administration-edit', AdministrationEdit);
